import { toast } from 'react-toastify'
import TokenService from 'services/token.service'
import type { GetWsStepStatus, GetWsStepStatuses, StepNotification } from 'share/types'

import { baseUrl } from './constants'

export const randomId = (): string => ((Math.random() * Math.pow(36, 6)) | 0).toString(36)

export const genNumArr = (length: number) => Array.from({ length }, (_, i) => i + 1)

export const formatPriceNumber = (x: number, delimiter?: string): string => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, delimiter || ' ')
}

export const numberWithSpaces = (x: string | number | undefined | null) => {
  if (x === undefined || x === null) return
  if (typeof x === 'string') {
    return x.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
  }
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
}

export const removeExtraWhitespace = (str: string) => str.replace(/\s+/g, ' ').trim()

export const removeAllWhitespace = (str: string) => str.replace(/\s+/g, '').trim()

export const downloadFileWithFetch = (id: string | null, filename = '') => {
  try {
    if (!id) return toast.error('Файл отсутствует')
    fetch(`${baseUrl}/credits/unsigned_documents/${id}`, {
      headers: {
        Authorization: `Bearer ${TokenService.getAccessToken()}`
      }
    })
      .then(res => res.blob())
      .then(data => {
        const fileURL = URL.createObjectURL(data)
        const a = document.createElement('a')
        a.href = fileURL
        a.download = filename
        a.click()
        a.remove()
      })
  } catch (err) {
    console.log(err)
  }
}

export const downloadFile = (url: string | undefined | null, filename = '') => {
  if (!url) return toast.error('Файл отсутствует')
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  link.target = '_blank'
  link.click()
}

export const getDearUserText = ({
  gender = undefined,
  first_name = '',
  middle_name = ''
}: {
  gender: 'FEMALE' | 'MALE' | undefined
  first_name: string | undefined | null
  middle_name: string | undefined | null
}) => {
  const lang = localStorage.getItem('i18nextLng')
  if (!gender) return `${lang === 'ru' ? 'Уважаемый' : 'Құрметті'} клиент!`
  else if (gender === 'MALE')
    return `${lang === 'ru' ? 'Уважаемый' : 'Құрметті'} ${first_name || ''} ${middle_name || ''}!`
  else if (gender === 'FEMALE')
    return `${lang === 'ru' ? 'Уважаемая' : 'Құрметті'} ${first_name || ''} ${middle_name || ''}!`
  return ''
}

export const getRandomNumberBetweenRange = (min: number, max: number) => {
  return Math.floor(Math.random() * (max - min + 1) + min)
}

export const getUserInitials = (...args: Array<string | undefined | null>) => {
  return args
    .filter(str => str)
    .map(str => str?.charAt(0).toUpperCase())
    .join('.')
}

// TODO: Поменять REJECTED на FAILED и переделать везде где идет проверка на REJECTED
export const getWsStepStatus = (step?: StepNotification | null): GetWsStepStatus => {
  if (!step) return 'STEP_NOT_STARTED'

  if (step.value.is_final) {
    if (step.value.is_success) return 'DONE'
    else if (step.value.can_retry && step.value.is_success === false) return 'RETRY'
    else if (!step.value.can_retry && step.value.is_success === false) return 'REJECTED'
  } else if (step.value.is_success === null) return 'IN_PROGRESS'
}

export const getWsStepStatuses = (...steps: Array<StepNotification | null | undefined>): GetWsStepStatuses => {
  if (!steps.length) throw Error('steps not provided!')

  if (steps.every(step => step && step.value.is_final && step.value.is_success)) return 'DONE'
  else if (steps.every(step => !step)) return 'STEPS_NOT_STARTED'
  else if (steps.some(step => step && !step.value.is_final && step.value.is_success === null)) return 'IN_PROGRESS'
  else if (steps.some(step => step && step.value.is_final && step.value.is_success === false)) return 'FAILED'
}

export const isStepHaveData = <T>(data: unknown): data is T => {
  return typeof data === 'object' && data !== null && data !== undefined
}
